export default "__VITE_ASSET__b0a2a380__"